import PropTypes from 'prop-types';

export default {
  background: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  cta_text: PropTypes.string,
  label: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  summary_only: PropTypes.bool.isRequired,
  supports_custom_banner_image: PropTypes.bool.isRequired,
  truncate: PropTypes.bool.isRequired,
};
